import { withStyles } from '@material-ui/core';
import { compose } from 'redux';
import { connect } from 'react-redux';
import Tabs from './Tabs';
import styles from './Tabs.styles';

const mapStateToProps = ({ clientingModule }) => ({
  isTopPadded: clientingModule?.voice.hasCallInProgress && clientingModule?.voice.isMinimized,
});

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
)(Tabs);
